// hooks/use-localhost.js
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'

export const useIsLocalhost = () => {
    const {req} = useServerContext()

    if (req) {
        return req.hostname === 'localhost' || req.hostname === '127.0.0.1'
    }

    if (typeof window !== 'undefined') {
        return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    }

    return false
}
